import styled from "styled-components";

export const EventItemStyled = styled.div`
  border: 2px solid ${({ theme }) => theme.COLORS.GRAY_8};
  display: flex;
  .event_item_color {
    border-right: 2px solid ${({ theme }) => theme.COLORS.GRAY_8};
    width: 15px;
    background-color: ${({ theme, color }) => color || theme.COLORS.GREEN_2};
  }
  .event_item_box {
    padding-left: 6px;
    flex: 1;
    .event_item_name {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .event_item_event {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
  }

  .theme_standard {
  }
`;
